import { render, staticRenderFns } from "./GateEntryLogsTable.vue?vue&type=template&id=6006fad8&scoped=true&"
import script from "./GateEntryLogsTable.vue?vue&type=script&lang=js&"
export * from "./GateEntryLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./GateEntryLogsTable.vue?vue&type=style&index=0&id=6006fad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006fad8",
  null
  
)

export default component.exports